try {
    const Form = require('./form')
    const View = require('./view')
    const ExtensionService = require('live/services/extension')

    const pwda = {
        name: 'PWDA Normalizer',
        type: 'liverig-pwda-normalizer',
        origin: 'Plugin PWDA',
        icon: '/content/plugin-pwda/pwda-normalizer.png',
        ui: {
            form: Form,
            view: View
        }
    }

    ExtensionService.register(pwda)
} catch (e) {
    console.error(e)
}
